module.exports = __webpack_public_path__ + "img/a973b96113a74457826f89222e8f94f3-1440.2df31deb.jpg";